'use strict';

angular.module('app', [
    // Third party modules
    'ui.router',
    'ui.bootstrap',

    'js-data',
    'ngAnimate',
    'ngTouch',
    'ngSanitize',
    'hm.readmore',
    'duScroll',
    'color.picker',
    //'720kb.socialshare',
    'angulartics',
    'angulartics.google.analytics',

    'templates',
    'header',
    'dashboard',
    'programme',
    'login',
    'forgot',
    'footer',
    'listUtils',
    'userSettings',
    'btorfs.multiselect',

    // In house modules
    'ngKomondor',
    'ngKomondorEditor',
    'ngKomondorMediaLibrary',
    'ngKomondorAccess',

    'admin',
    'admin.user',
    'admin.programme',
    'admin.category',
    'admin.article',
    'admin.article-page',
    'admin.template',
    'admin.language',
    'admin.season',
    'admin.video',
    'admin.iframe',
])

.config(function ($locationProvider)
{
    $locationProvider
        .html5Mode(true)
        .hashPrefix('!');
})

/**
 * Set the default state after login
 */
.config(function (kdLoginProvider)
{
    kdLoginProvider.setAfterLoginState('admin.programmes');
})

.config(function ($provide)
{
    $provide.decorator('kdLogin', function ($delegate, kdAuth, DS) {

        //Removed DS.clear();
        $delegate.onLoginSuccess = function (user)
        {
            user = DS.inject('User', user);
            kdAuth.setUser(user);

            return user;
        };

        return $delegate;
    });
})

.constant('roles', {
    admin: 1,
})

/**
 * Define the printer gate
 */
.config(function (kdGateProvider, roles)
{

    kdGateProvider.before(function (user)
    {
        if (user && user.role_id === roles.admin) {
            return true;
        }
    });

    kdGateProvider.define('user', function (user) {
        return !!user;
    });

    kdGateProvider.define('admin', function (user) {
        if (user) {
            return user.role_id === roles.admin;
        }

        return false;
    });
})

.config(function (DSProvider)
{
    DSProvider.defaults.basePath = '/api/';
})

/**
 * Create the require parent states
 */
.config(function ($stateProvider, $urlRouterProvider) {

    $urlRouterProvider.otherwise('/');

    $stateProvider
        .state('app', {
            abstract: true,
            views: {
                header: {
                    templateUrl: 'modules/header/header.html',
                    controller: 'HeaderCtrl'
                },
                footer: {
                    templateUrl: 'modules/footer/footer.html',
                    controller: 'FooterCtrl'
                },
                '': {
                    template: '<div class="container-full-width"><ui-view></ui-view></div>'
                }
            },
            resolve: {

            }
        });

    $stateProvider
        .state('guest', {
            abstract: true,
            views: {
                header: {
                    templateUrl: 'modules/header/header.html',
                    controller: 'HeaderCtrl'
                },
                footer: {
                    templateUrl: 'modules/footer/footer.html',
                    controller: 'FooterCtrl'
                },
                '': {
                    template: '<div class="container-full-width"><ui-view></ui-view></div>'
                }
            }
        });
})

/**
 * Scroll to top when state changed.
 */
.run(function ($rootScope, $location, $window, $document)
{
    $rootScope.$on('$stateChangeSuccess', function() {
        $document[0].body.scrollTop = 0;
        $document[0].documentElement.scrollTop = 0;
    });
})

// google analytics GA4
// .run(function ($rootScope, $location, $window, $document) {
//     $window.dataLayer = $window.dataLayer || [];
//     function gtag(){$window.dataLayer.push(arguments);}
    
//     $rootScope.$on('$stateChangeSuccess', function(){
//         gtag('event', 'page_view', {
//             page_title: $document[0].title,
//             page_location: $location.host(),
//             page_path: $location.path(),
//             send_page_view: true
//         });
//     });
// })

/**
 * Show state errors
 */
.run(function ($rootScope, $log)
{
    $rootScope.$on('$stateChangeError',
    function (event, toState, toParams, fromState, fromParams, error) {
        $log.debug('state change error');
        throw error;
    });
});
